import { mobileApiRequest } from '../../apiRequests'

/**
 * Submit user feedback for a chat query result
 * @param {string} correlationID - Unique identifier for the query result
 * @param {string} feedbackType - Type of feedback: 'POSITIVE', 'NEGATIVE', or 'CORRECTION'
 * @param {string|null} userCorrection - User's correction text (only for CORRECTION type)
 * @returns {Promise} - API response
 */
export async function submitQueryFeedbackRequest(
    correlationID,
    feedbackType,
    userCorrection = null
) {
    const payload = {
        action: 'submitQueryFeedback',
        correlationID,
        feedbackType,
        userCorrection,
        timestamp: new Date().toISOString(),
    }

    return await mobileApiRequest(payload)
}
